import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './TilbakestillPassord.css';

function TilbakestillPassord() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nytt_passord: '',
    bekreft_passord: '',
  });
  const [tokenValid, setTokenValid] = useState(null);
  const [epost, setEpost] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Verifiser token når siden lastes
    const verifyToken = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/verifiser-reset-token/${token}`
        );

        const data = await response.json();

        if (response.ok) {
          setTokenValid(true);
          setEpost(data.epost);
        } else {
          setTokenValid(false);
          setError(data.error || 'Ugyldig eller utløpt link');
        }
      } catch (err) {
        console.error('Feil ved verifisering av token:', err);
        setTokenValid(false);
        setError('Kunne ikke verifisere linken. Sjekk internettforbindelsen din.');
      } finally {
        setChecking(false);
      }
    };

    verifyToken();
  }, [token]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Valider passord
    if (formData.nytt_passord.length < 8) {
      setError('Passordet må være minst 8 tegn');
      return;
    }

    if (formData.nytt_passord !== formData.bekreft_passord) {
      setError('Passordene stemmer ikke overens');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/tilbakestill-passord`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            reset_token: token,
            nytt_passord: formData.nytt_passord,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage('Passordet ditt er tilbakestilt! Omdirigerer til innlogging...');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setError(data.error || 'Noe gikk galt. Prøv igjen.');
      }
    } catch (err) {
      console.error('Feil ved tilbakestilling av passord:', err);
      setError('Kunne ikke tilbakestille passord. Sjekk internettforbindelsen din.');
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div className="tilbakestill-passord-container">
        <div className="tilbakestill-passord-box">
          <h1>Takstmann System</h1>
          <p className="info-text">Verifiserer link...</p>
        </div>
      </div>
    );
  }

  if (tokenValid === false) {
    return (
      <div className="tilbakestill-passord-container">
        <div className="tilbakestill-passord-box">
          <h1>Takstmann System</h1>
          <h2>Ugyldig link</h2>

          <div className="error-message">{error}</div>

          <p className="info-text">
            Linken kan være utløpt eller allerede brukt. Vennligst be om en ny link.
          </p>

          <p className="back-link">
            <Link to="/glemt-passord">Be om ny link</Link>
          </p>
          <p className="back-link">
            <Link to="/login">Tilbake til innlogging</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="tilbakestill-passord-container">
      <div className="tilbakestill-passord-box">
        <h1>Takstmann System</h1>
        <h2>Tilbakestill passord</h2>

        <p className="info-text">
          Tilbakestiller passord for: <strong>{epost}</strong>
        </p>

        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nytt_passord">Nytt passord</label>
            <input
              type="password"
              id="nytt_passord"
              name="nytt_passord"
              value={formData.nytt_passord}
              onChange={handleChange}
              required
              autoComplete="new-password"
              placeholder="Minst 8 tegn"
            />
          </div>

          <div className="form-group">
            <label htmlFor="bekreft_passord">Bekreft passord</label>
            <input
              type="password"
              id="bekreft_passord"
              name="bekreft_passord"
              value={formData.bekreft_passord}
              onChange={handleChange}
              required
              autoComplete="new-password"
              placeholder="Skriv passordet igjen"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Tilbakestiller...' : 'Tilbakestill passord'}
          </button>
        </form>

        <p className="back-link">
          <Link to="/login">Tilbake til innlogging</Link>
        </p>
      </div>
    </div>
  );
}

export default TilbakestillPassord;
